import { render, staticRenderFns } from "./country.vue?vue&type=template&id=315b21c8&scoped=true"
import script from "./country.vue?vue&type=script&lang=js"
export * from "./country.vue?vue&type=script&lang=js"
import style0 from "./country.vue?vue&type=style&index=0&id=315b21c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315b21c8",
  null
  
)

export default component.exports